import { render, staticRenderFns } from "./pres.vue?vue&type=template&id=96c43a1a&scoped=true&"
import script from "./pres.vue?vue&type=script&lang=js&"
export * from "./pres.vue?vue&type=script&lang=js&"
import style0 from "./pres.vue?vue&type=style&index=0&id=96c43a1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c43a1a",
  null
  
)

export default component.exports